import { hashHistory } from 'react-router';
import { LOGOUT, RECONNECT_ACTIVATE } from '../constants';
// Check in localStorage for user's credentials 
export const auth = function () { 
	return JSON.parse(window.localStorage.getItem('celledCredentials')) 
};

/**
 * Whether a request captured for replay still belongs to the learner who is logged in (LMSNEXT-1325).
 *
 * A request in flight when the learner logs out fails afterwards and asks to be replayed, carrying
 * the Authorization header of the session that ended. Replaying it would send the old token, and
 * its reply would be processed into whatever lesson is open by then.
 */
export const requestBelongsToCurrentSession = (requestConfig) => {
	const authorization = requestConfig && requestConfig.headers && requestConfig.headers.Authorization;
	if (!authorization) return true; // nothing session-specific to compare

	const credentials = auth();
	return Boolean(credentials) && authorization === `Bearer ${credentials.celledAuthToken}`;
};

/**
 * This method should be called from each try / catch block from the sagas to check for common errors.
 * 
 * @param {Object} error The error thrown by celled_client (axios)
 * @param {Object} businessError The business error to return in case common error logic was not triggered
 */
export const checkCommonErrors = (error, businessError) => {
	if (error.response) { // The request was made and the server responded with a status code that falls out of the range of 2xx
		if ((error.response.status === 401 || error.response.status === 403)) { // logout procedure
			const errorMessage = error.response ? error.response.data.message : 'Connection problem';
			window.localStorage.clear();
			hashHistory.push('/');
			return {
				type: LOGOUT,
				notification: {
					message: errorMessage,
					className: 'error',
					type: 'mainCourse',
				},
			};
		} else { // if you don't evaluate error.response.data, error.response.status and error.response.headers.
			// For now it returns the business error, it should be implemented later.
			return businessError;
		}
	  } else if (error.request) { // The request was made but no response was received `error.request` is an instance of XMLHttpRequest in the browser.
		// A request made through axiosRetryOn is replayed by the reconnect flow, so the learner is
		// already being told what is happening: showing the caller's 'Connection problem' as well
		// would leave an error on screen even once the replay succeeded. Anything else reports its
		// own error -- this used to return RECONNECT_TRY, which claimed an attempt was under way
		// while naming no request to attempt, leaving 'Reconnecting...' with nothing to clear it
		// (LMSNEXT-1325).
		if (error.config && error.config.replayable) {
			return { type: RECONNECT_ACTIVATE, payload: error.config };
		}
		return businessError;
	  } else { // Otherwise the business error returns.
		return businessError;
	  }
}
